
import { Spacing, MediaQueries } from 'UI'

export default (theme) => ({
  container: {
    padding: Spacing(10, 0, 0, 0)
  },
  newBadge: {
    width: 65,
    border: `1px solid ${theme.error[200]}`,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    borderRadius: 4,
    textTransform: 'uppercase'
  },
  [MediaQueries.tablet]: {
    container: {
      padding: Spacing(4, 0, 0, 0)
    }
  },
  [MediaQueries.mobile]: {
    container: {
      padding: Spacing(4, 0, 0, 0)
    }
  }
})
